// @flow
import { styled } from 'mz-ui-kit'
import * as primary from './appearance/primary'
import * as primaryInverse from './appearance/inverse'
import { getAppearanceFunc } from '../../utils'

// Constants
const BASE_CLASS = 'switch-field'
const APPEARANCES = {
  primary,
  inverse: primaryInverse,
  'primary-inverse': primaryInverse, // DEPRECATED
}

const createAppearanceFunc = getAppearanceFunc(APPEARANCES, 'primary')

export const Container = styled(
  {
    base: 'div',
    mozClassName: ({ $appearance }) => [
      BASE_CLASS,
      `${BASE_CLASS}--${$appearance}`,
    ],
  },
  createAppearanceFunc('Container')
)

export const Switch = styled(
  {
    base: 'div',
    mozClassName: `${BASE_CLASS}__switch`,
  },
  createAppearanceFunc('Switch')
)

export const Background = styled(
  {
    base: 'div',
    mozClassName: `${BASE_CLASS}__background`,
  },
  createAppearanceFunc('Background')
)

export const Label = styled(
  {
    base: 'label',
    mozClassName: `${BASE_CLASS}__label`,
  },
  createAppearanceFunc('Label')
)

export const Toggler = styled(
  {
    base: 'button',
    mozClassName: `${BASE_CLASS}__toggler`,
  },
  createAppearanceFunc('Toggler')
)

export const ValueText = styled(
  {
    base: 'div',
    mozClassName: `${BASE_CLASS}__value`,
  },
  createAppearanceFunc('ValueText')
)
